import { useEnumStore } from '@stores/enum';
import { transformParameterQuery } from '@utils/parameters';

export default function (values) {
  const enums = useEnumStore();
  const parameters = transformParameterQuery(values, 't', enums.contentParameters)
    .filter(parameter => parameter.valueText === undefined);
  return parameters.length ? parameters : null;
}
